import React from 'react';
import Navbar from '../components/layout/Navbar';
import HeroAlt1 from '../components/sections/HeroAlt1';
import AboutAlt2 from '../components/sections/AboutAlt2';
import LogoSlider from '../components/sections/LogoSlider';
import ServicesAlt4 from '../components/sections/ServicesAlt4';
import PortfolioSlider from '../components/sections/PortfolioSlider';
import BrandReviewsSlider2 from '../components/sections/BrandReviewsSlider2';
import FounderMessage4 from '../components/sections/FounderMessage4';
import Banner4 from '../components/sections/Banner4';
import CaseStudies6 from '../components/sections/CaseStudies6';
import Process4 from '../components/sections/Process4';
import Blogs1 from '../components/sections/Blogs1';
import Footer1 from '../components/sections/Footer1';

const Home = () => {
  return (
    <div className="min-h-screen bg-cream dark:bg-black">
      <HeroAlt1 />
      <AboutAlt2 />
      <LogoSlider />
      <ServicesAlt4 />
      <PortfolioSlider />
      <BrandReviewsSlider2 />
      <Banner4 />
      <CaseStudies6 />
      <Process4 />
      <Blogs1 />
    </div>
  );
};

export default Home;
